import { render } from "./SourceItem.vue?vue&type=template&id=4c16fb3d&scoped=true&ts=true"
import script from "./SourceItem.vue?vue&type=script&lang=ts"
export * from "./SourceItem.vue?vue&type=script&lang=ts"

import "./SourceItem.vue?vue&type=style&index=0&id=4c16fb3d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c16fb3d"]])

export default __exports__